import { render, staticRenderFns } from "./FilterBar.vue?vue&type=template&id=2fdfa6a8"
import script from "./FilterBar.vue?vue&type=script&lang=ts"
export * from "./FilterBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports